/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ActivityCustomer,
  BulkActionEnqueuedResponse,
  FoodActivityRecordUpdate,
  FoodOperationActivityDetail,
  FoodOperationActivityRecord,
  FoodOperationPreviewResults,
  OperationActivityCoverage,
  OperationActivityUpdateResponse,
  PackagingOperationActivityRecord,
  PackagingOperationActivityRecordUpdate,
  PackagingOperationActivityRetrieve,
  PackagingOperationActivityUpdate,
  PackagingOperationPreviewResults,
  PaginatedFoodOperationActivitiesListList,
  PaginatedFoodOperationActivityRecordList,
  PaginatedPackagingOperationActivitiesListList,
  PaginatedPackagingOperationActivityRecordList,
  PaginatedUncategorisedSoldGoodList,
  PatchedFoodActivityRecordUpdate,
  PatchedFoodOperationActivityDetail,
  PatchedPackagingOperationActivityRecordUpdate,
  PatchedPackagingOperationActivityUpdate,
  PatchedSoldGoodsBulkActionRequest,
  SoldGoodsFoodListParams,
  SoldGoodsFoodPreviewRetrieveParams,
  SoldGoodsFoodRecordsListParams,
  SoldGoodsPackagingListParams,
  SoldGoodsPackagingPreviewRetrieveParams,
  SoldGoodsPackagingRecordsListParams,
  SoldGoodsUncategorisedListParams
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const soldGoodsDestroy = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/sold-goods/${activityUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getSoldGoodsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsDestroy>>, TError,{activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsDestroy>>, TError,{activityUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsDestroy>>, {activityUuid: string}> = (props) => {
          const {activityUuid} = props ?? {};

          return  soldGoodsDestroy(activityUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsDestroy>>>
    
    export type SoldGoodsDestroyMutationError = unknown

    export const useSoldGoodsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsDestroy>>, TError,{activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsDestroy>>,
        TError,
        {activityUuid: string},
        TContext
      > => {

      const mutationOptions = getSoldGoodsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsRecordsDestroy = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/sold-goods/${activityUuid}/records/${recordUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getSoldGoodsRecordsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>, {activityUuid: string;recordUuid: string}> = (props) => {
          const {activityUuid,recordUuid} = props ?? {};

          return  soldGoodsRecordsDestroy(activityUuid,recordUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsRecordsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>>
    
    export type SoldGoodsRecordsDestroyMutationError = unknown

    export const useSoldGoodsRecordsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsRecordsDestroy>>,
        TError,
        {activityUuid: string;recordUuid: string},
        TContext
      > => {

      const mutationOptions = getSoldGoodsRecordsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Enqueue a sold-goods bulk action.
 */
export const soldGoodsBulkPartialUpdate = (
    patchedSoldGoodsBulkActionRequest: PatchedSoldGoodsBulkActionRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<BulkActionEnqueuedResponse>(
      {url: `/sold-goods/bulk`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSoldGoodsBulkActionRequest
    },
      options);
    }
  


export const getSoldGoodsBulkPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>, TError,{data: PatchedSoldGoodsBulkActionRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>, TError,{data: PatchedSoldGoodsBulkActionRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>, {data: PatchedSoldGoodsBulkActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  soldGoodsBulkPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsBulkPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>>
    export type SoldGoodsBulkPartialUpdateMutationBody = PatchedSoldGoodsBulkActionRequest
    export type SoldGoodsBulkPartialUpdateMutationError = unknown

    export const useSoldGoodsBulkPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>, TError,{data: PatchedSoldGoodsBulkActionRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsBulkPartialUpdate>>,
        TError,
        {data: PatchedSoldGoodsBulkActionRequest},
        TContext
      > => {

      const mutationOptions = getSoldGoodsBulkPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List the organization's customers (for report/filter pickers).
 */
export const soldGoodsCustomersList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityCustomer[]>(
      {url: `/sold-goods/customers`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsCustomersListQueryKey = () => {
    return [`/sold-goods/customers`] as const;
    }

    
export const getSoldGoodsCustomersListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsCustomersListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsCustomersList>>> = ({ signal }) => soldGoodsCustomersList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsCustomersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsCustomersList>>>
export type SoldGoodsCustomersListInfiniteQueryError = unknown

export const useSoldGoodsCustomersListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsCustomersListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsCustomersListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsCustomersListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsCustomersList>>> = ({ signal }) => soldGoodsCustomersList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsCustomersListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsCustomersList>>>
export type SoldGoodsCustomersListQueryError = unknown

export const useSoldGoodsCustomersList = <TData = Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsCustomersList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsCustomersListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodList = (
    params?: SoldGoodsFoodListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedFoodOperationActivitiesListList>(
      {url: `/sold-goods/food`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsFoodListQueryKey = (params?: SoldGoodsFoodListParams,) => {
    return [`/sold-goods/food`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsFoodListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodList>>, TError = unknown>(params?: SoldGoodsFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodList>>> = ({ signal, pageParam }) => soldGoodsFoodList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodList>>>
export type SoldGoodsFoodListInfiniteQueryError = unknown

export const useSoldGoodsFoodListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodList>>, TError = unknown>(
 params?: SoldGoodsFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodList>>, TError = unknown>(params?: SoldGoodsFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodList>>> = ({ signal }) => soldGoodsFoodList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodList>>>
export type SoldGoodsFoodListQueryError = unknown

export const useSoldGoodsFoodList = <TData = Awaited<ReturnType<typeof soldGoodsFoodList>>, TError = unknown>(
 params?: SoldGoodsFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodRetrieve = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodOperationActivityDetail>(
      {url: `/sold-goods/food/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsFoodRetrieveQueryKey = (activityUuid: string,) => {
    return [`/sold-goods/food/${activityUuid}`] as const;
    }

    
export const getSoldGoodsFoodRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>> = ({ signal }) => soldGoodsFoodRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>>
export type SoldGoodsFoodRetrieveInfiniteQueryError = unknown

export const useSoldGoodsFoodRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRetrieveInfiniteQueryOptions(activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>> = ({ signal }) => soldGoodsFoodRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>>
export type SoldGoodsFoodRetrieveQueryError = unknown

export const useSoldGoodsFoodRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRetrieveQueryOptions(activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodUpdate = (
    activityUuid: string,
    foodOperationActivityDetail: NonReadonly<FoodOperationActivityDetail>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<FoodOperationActivityDetail>(
      {url: `/sold-goods/food/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: foodOperationActivityDetail
    },
      options);
    }
  


export const getSoldGoodsFoodUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodOperationActivityDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodOperationActivityDetail>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsFoodUpdate>>, {activityUuid: string;data: NonReadonly<FoodOperationActivityDetail>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  soldGoodsFoodUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsFoodUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodUpdate>>>
    export type SoldGoodsFoodUpdateMutationBody = NonReadonly<FoodOperationActivityDetail>
    export type SoldGoodsFoodUpdateMutationError = unknown

    export const useSoldGoodsFoodUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodOperationActivityDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsFoodUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<FoodOperationActivityDetail>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsFoodUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsFoodPartialUpdate = (
    activityUuid: string,
    patchedFoodOperationActivityDetail: NonReadonly<PatchedFoodOperationActivityDetail>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<FoodOperationActivityDetail>(
      {url: `/sold-goods/food/${activityUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFoodOperationActivityDetail
    },
      options);
    }
  


export const getSoldGoodsFoodPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodOperationActivityDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodOperationActivityDetail>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>, {activityUuid: string;data: NonReadonly<PatchedFoodOperationActivityDetail>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  soldGoodsFoodPartialUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsFoodPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>>
    export type SoldGoodsFoodPartialUpdateMutationBody = NonReadonly<PatchedFoodOperationActivityDetail>
    export type SoldGoodsFoodPartialUpdateMutationError = unknown

    export const useSoldGoodsFoodPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodOperationActivityDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsFoodPartialUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PatchedFoodOperationActivityDetail>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsFoodPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsFoodRecordsList = (
    activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedFoodOperationActivityRecordList>(
      {url: `/sold-goods/food/${activityUuid}/records`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsFoodRecordsListQueryKey = (activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams,) => {
    return [`/sold-goods/food/${activityUuid}/records`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsFoodRecordsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError = unknown>(activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>> = ({ signal, pageParam }) => soldGoodsFoodRecordsList(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRecordsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>>
export type SoldGoodsFoodRecordsListInfiniteQueryError = unknown

export const useSoldGoodsFoodRecordsListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRecordsListInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError = unknown>(activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>> = ({ signal }) => soldGoodsFoodRecordsList(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>>
export type SoldGoodsFoodRecordsListQueryError = unknown

export const useSoldGoodsFoodRecordsList = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: SoldGoodsFoodRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRecordsListQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodRecordsRetrieve = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodOperationActivityRecord>(
      {url: `/sold-goods/food/${activityUuid}/records/${recordUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsFoodRecordsRetrieveQueryKey = (activityUuid: string,
    recordUuid: string,) => {
    return [`/sold-goods/food/${activityUuid}/records/${recordUuid}`] as const;
    }

    
export const getSoldGoodsFoodRecordsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>> = ({ signal }) => soldGoodsFoodRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRecordsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>>
export type SoldGoodsFoodRecordsRetrieveInfiniteQueryError = unknown

export const useSoldGoodsFoodRecordsRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRecordsRetrieveInfiniteQueryOptions(activityUuid,recordUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>> = ({ signal }) => soldGoodsFoodRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>>
export type SoldGoodsFoodRecordsRetrieveQueryError = unknown

export const useSoldGoodsFoodRecordsRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodRecordsRetrieveQueryOptions(activityUuid,recordUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodRecordsUpdate = (
    activityUuid: string,
    recordUuid: string,
    foodActivityRecordUpdate: NonReadonly<FoodActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationActivityUpdateResponse>(
      {url: `/sold-goods/food/${activityUuid}/records/${recordUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: foodActivityRecordUpdate
    },
      options);
    }
  


export const getSoldGoodsFoodRecordsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  soldGoodsFoodRecordsUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsFoodRecordsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>>
    export type SoldGoodsFoodRecordsUpdateMutationBody = NonReadonly<FoodActivityRecordUpdate>
    export type SoldGoodsFoodRecordsUpdateMutationError = unknown

    export const useSoldGoodsFoodRecordsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsFoodRecordsUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsFoodRecordsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsFoodRecordsPartialUpdate = (
    activityUuid: string,
    recordUuid: string,
    patchedFoodActivityRecordUpdate: NonReadonly<PatchedFoodActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationActivityUpdateResponse>(
      {url: `/sold-goods/food/${activityUuid}/records/${recordUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFoodActivityRecordUpdate
    },
      options);
    }
  


export const getSoldGoodsFoodRecordsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  soldGoodsFoodRecordsPartialUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsFoodRecordsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>>
    export type SoldGoodsFoodRecordsPartialUpdateMutationBody = NonReadonly<PatchedFoodActivityRecordUpdate>
    export type SoldGoodsFoodRecordsPartialUpdateMutationError = unknown

    export const useSoldGoodsFoodRecordsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsFoodRecordsPartialUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsFoodRecordsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsFoodCoverageRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<OperationActivityCoverage>(
      {url: `/sold-goods/food/coverage`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsFoodCoverageRetrieveQueryKey = () => {
    return [`/sold-goods/food/coverage`] as const;
    }

    
export const getSoldGoodsFoodCoverageRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>> = ({ signal }) => soldGoodsFoodCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodCoverageRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>>
export type SoldGoodsFoodCoverageRetrieveInfiniteQueryError = unknown

export const useSoldGoodsFoodCoverageRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodCoverageRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodCoverageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>> = ({ signal }) => soldGoodsFoodCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodCoverageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>>
export type SoldGoodsFoodCoverageRetrieveQueryError = unknown

export const useSoldGoodsFoodCoverageRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodCoverageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsFoodPreviewRetrieve = (
    params?: SoldGoodsFoodPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodOperationPreviewResults>(
      {url: `/sold-goods/food/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsFoodPreviewRetrieveQueryKey = (params?: SoldGoodsFoodPreviewRetrieveParams,) => {
    return [`/sold-goods/food/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsFoodPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError = unknown>(params?: SoldGoodsFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>> = ({ signal, pageParam }) => soldGoodsFoodPreviewRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>>
export type SoldGoodsFoodPreviewRetrieveInfiniteQueryError = unknown

export const useSoldGoodsFoodPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError = unknown>(
 params?: SoldGoodsFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodPreviewRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsFoodPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError = unknown>(params?: SoldGoodsFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsFoodPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>> = ({ signal }) => soldGoodsFoodPreviewRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsFoodPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>>
export type SoldGoodsFoodPreviewRetrieveQueryError = unknown

export const useSoldGoodsFoodPreviewRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError = unknown>(
 params?: SoldGoodsFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsFoodPreviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingList = (
    params?: SoldGoodsPackagingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedPackagingOperationActivitiesListList>(
      {url: `/sold-goods/packaging`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsPackagingListQueryKey = (params?: SoldGoodsPackagingListParams,) => {
    return [`/sold-goods/packaging`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsPackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError = unknown>(params?: SoldGoodsPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingList>>> = ({ signal, pageParam }) => soldGoodsPackagingList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingList>>>
export type SoldGoodsPackagingListInfiniteQueryError = unknown

export const useSoldGoodsPackagingListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError = unknown>(
 params?: SoldGoodsPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError = unknown>(params?: SoldGoodsPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingList>>> = ({ signal }) => soldGoodsPackagingList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingList>>>
export type SoldGoodsPackagingListQueryError = unknown

export const useSoldGoodsPackagingList = <TData = Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError = unknown>(
 params?: SoldGoodsPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingRetrieve = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingOperationActivityRetrieve>(
      {url: `/sold-goods/packaging/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsPackagingRetrieveQueryKey = (activityUuid: string,) => {
    return [`/sold-goods/packaging/${activityUuid}`] as const;
    }

    
export const getSoldGoodsPackagingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>> = ({ signal }) => soldGoodsPackagingRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>>
export type SoldGoodsPackagingRetrieveInfiniteQueryError = unknown

export const useSoldGoodsPackagingRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRetrieveInfiniteQueryOptions(activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>> = ({ signal }) => soldGoodsPackagingRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>>
export type SoldGoodsPackagingRetrieveQueryError = unknown

export const useSoldGoodsPackagingRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRetrieveQueryOptions(activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingUpdate = (
    activityUuid: string,
    packagingOperationActivityUpdate: NonReadonly<PackagingOperationActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingOperationActivityUpdate>(
      {url: `/sold-goods/packaging/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingOperationActivityUpdate
    },
      options);
    }
  


export const getSoldGoodsPackagingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingOperationActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingOperationActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>, {activityUuid: string;data: NonReadonly<PackagingOperationActivityUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  soldGoodsPackagingUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsPackagingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>>
    export type SoldGoodsPackagingUpdateMutationBody = NonReadonly<PackagingOperationActivityUpdate>
    export type SoldGoodsPackagingUpdateMutationError = unknown

    export const useSoldGoodsPackagingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingOperationActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsPackagingUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PackagingOperationActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsPackagingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsPackagingPartialUpdate = (
    activityUuid: string,
    patchedPackagingOperationActivityUpdate: NonReadonly<PatchedPackagingOperationActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingOperationActivityUpdate>(
      {url: `/sold-goods/packaging/${activityUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPackagingOperationActivityUpdate
    },
      options);
    }
  


export const getSoldGoodsPackagingPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingOperationActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingOperationActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>, {activityUuid: string;data: NonReadonly<PatchedPackagingOperationActivityUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  soldGoodsPackagingPartialUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsPackagingPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>>
    export type SoldGoodsPackagingPartialUpdateMutationBody = NonReadonly<PatchedPackagingOperationActivityUpdate>
    export type SoldGoodsPackagingPartialUpdateMutationError = unknown

    export const useSoldGoodsPackagingPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingOperationActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsPackagingPartialUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PatchedPackagingOperationActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsPackagingPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsPackagingRecordsList = (
    activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedPackagingOperationActivityRecordList>(
      {url: `/sold-goods/packaging/${activityUuid}/records`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsPackagingRecordsListQueryKey = (activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams,) => {
    return [`/sold-goods/packaging/${activityUuid}/records`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsPackagingRecordsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError = unknown>(activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>> = ({ signal, pageParam }) => soldGoodsPackagingRecordsList(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRecordsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>>
export type SoldGoodsPackagingRecordsListInfiniteQueryError = unknown

export const useSoldGoodsPackagingRecordsListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRecordsListInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError = unknown>(activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>> = ({ signal }) => soldGoodsPackagingRecordsList(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>>
export type SoldGoodsPackagingRecordsListQueryError = unknown

export const useSoldGoodsPackagingRecordsList = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: SoldGoodsPackagingRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRecordsListQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingRecordsRetrieve = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingOperationActivityRecord>(
      {url: `/sold-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsPackagingRecordsRetrieveQueryKey = (activityUuid: string,
    recordUuid: string,) => {
    return [`/sold-goods/packaging/${activityUuid}/records/${recordUuid}`] as const;
    }

    
export const getSoldGoodsPackagingRecordsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>> = ({ signal }) => soldGoodsPackagingRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRecordsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>>
export type SoldGoodsPackagingRecordsRetrieveInfiniteQueryError = unknown

export const useSoldGoodsPackagingRecordsRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRecordsRetrieveInfiniteQueryOptions(activityUuid,recordUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>> = ({ signal }) => soldGoodsPackagingRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>>
export type SoldGoodsPackagingRecordsRetrieveQueryError = unknown

export const useSoldGoodsPackagingRecordsRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingRecordsRetrieveQueryOptions(activityUuid,recordUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingRecordsUpdate = (
    activityUuid: string,
    recordUuid: string,
    packagingOperationActivityRecordUpdate: NonReadonly<PackagingOperationActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationActivityUpdateResponse>(
      {url: `/sold-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingOperationActivityRecordUpdate
    },
      options);
    }
  


export const getSoldGoodsPackagingRecordsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingOperationActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingOperationActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PackagingOperationActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  soldGoodsPackagingRecordsUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsPackagingRecordsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>>
    export type SoldGoodsPackagingRecordsUpdateMutationBody = NonReadonly<PackagingOperationActivityRecordUpdate>
    export type SoldGoodsPackagingRecordsUpdateMutationError = unknown

    export const useSoldGoodsPackagingRecordsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingOperationActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsPackagingRecordsUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PackagingOperationActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsPackagingRecordsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsPackagingRecordsPartialUpdate = (
    activityUuid: string,
    recordUuid: string,
    patchedPackagingOperationActivityRecordUpdate: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationActivityUpdateResponse>(
      {url: `/sold-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPackagingOperationActivityRecordUpdate
    },
      options);
    }
  


export const getSoldGoodsPackagingRecordsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  soldGoodsPackagingRecordsPartialUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SoldGoodsPackagingRecordsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>>
    export type SoldGoodsPackagingRecordsPartialUpdateMutationBody = NonReadonly<PatchedPackagingOperationActivityRecordUpdate>
    export type SoldGoodsPackagingRecordsPartialUpdateMutationError = unknown

    export const useSoldGoodsPackagingRecordsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof soldGoodsPackagingRecordsPartialUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingOperationActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getSoldGoodsPackagingRecordsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const soldGoodsPackagingCoverageRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<OperationActivityCoverage>(
      {url: `/sold-goods/packaging/coverage`, method: 'GET', signal
    },
      options);
    }
  

export const getSoldGoodsPackagingCoverageRetrieveQueryKey = () => {
    return [`/sold-goods/packaging/coverage`] as const;
    }

    
export const getSoldGoodsPackagingCoverageRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>> = ({ signal }) => soldGoodsPackagingCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingCoverageRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>>
export type SoldGoodsPackagingCoverageRetrieveInfiniteQueryError = unknown

export const useSoldGoodsPackagingCoverageRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingCoverageRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingCoverageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>> = ({ signal }) => soldGoodsPackagingCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingCoverageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>>
export type SoldGoodsPackagingCoverageRetrieveQueryError = unknown

export const useSoldGoodsPackagingCoverageRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingCoverageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const soldGoodsPackagingPreviewRetrieve = (
    params?: SoldGoodsPackagingPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingOperationPreviewResults>(
      {url: `/sold-goods/packaging/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsPackagingPreviewRetrieveQueryKey = (params?: SoldGoodsPackagingPreviewRetrieveParams,) => {
    return [`/sold-goods/packaging/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsPackagingPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError = unknown>(params?: SoldGoodsPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>> = ({ signal, pageParam }) => soldGoodsPackagingPreviewRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>>
export type SoldGoodsPackagingPreviewRetrieveInfiniteQueryError = unknown

export const useSoldGoodsPackagingPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError = unknown>(
 params?: SoldGoodsPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingPreviewRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsPackagingPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError = unknown>(params?: SoldGoodsPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsPackagingPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>> = ({ signal }) => soldGoodsPackagingPreviewRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsPackagingPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>>
export type SoldGoodsPackagingPreviewRetrieveQueryError = unknown

export const useSoldGoodsPackagingPreviewRetrieve = <TData = Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError = unknown>(
 params?: SoldGoodsPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsPackagingPreviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List excluded sold goods (item_type 'other' / 'uncertain').

Sold-goods sibling of ``ListOtherPurchasedGoodsView`` (still serving both excluded types). Excluded sold
goods are materialised as zero-emission ``other-purchased-goods``
OperationActivities, so this is activity-keyed: quantity / total_spend are
aggregated over the OperationActivityRecords (facet-aware) and the row carries
the same shape as the purchased hub. Facet filtering (sites / time_periods /
activity_imports / tags / customers / item_main_categories) reuses
``OperationActivityRecordFilterMixin``.
 */
export const soldGoodsUncategorisedList = (
    params?: SoldGoodsUncategorisedListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedUncategorisedSoldGoodList>(
      {url: `/sold-goods/uncategorised`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSoldGoodsUncategorisedListQueryKey = (params?: SoldGoodsUncategorisedListParams,) => {
    return [`/sold-goods/uncategorised`, ...(params ? [params]: [])] as const;
    }

    
export const getSoldGoodsUncategorisedListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError = unknown>(params?: SoldGoodsUncategorisedListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsUncategorisedListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>> = ({ signal, pageParam }) => soldGoodsUncategorisedList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsUncategorisedListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>>
export type SoldGoodsUncategorisedListInfiniteQueryError = unknown

export const useSoldGoodsUncategorisedListInfinite = <TData = Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError = unknown>(
 params?: SoldGoodsUncategorisedListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsUncategorisedListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSoldGoodsUncategorisedListQueryOptions = <TData = Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError = unknown>(params?: SoldGoodsUncategorisedListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSoldGoodsUncategorisedListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>> = ({ signal }) => soldGoodsUncategorisedList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData> & { queryKey: QueryKey }
}

export type SoldGoodsUncategorisedListQueryResult = NonNullable<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>>
export type SoldGoodsUncategorisedListQueryError = unknown

export const useSoldGoodsUncategorisedList = <TData = Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError = unknown>(
 params?: SoldGoodsUncategorisedListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof soldGoodsUncategorisedList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSoldGoodsUncategorisedListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



